<template>
  <b-tabs
    :value="value"
    :class="classes"
    type="is-boxed"
    :animated="false"
    :expanded="expanded"
    @input="$emit('input', $event)"
  >
    <slot></slot>
  </b-tabs>
</template>

<script>
export default {
  name: "TabsHorizontal",
  props: {
    value: String,
    classes: {
      type: String,
      default: 'tabs_horizontal',
    },
    expanded: {
      type: Boolean,
      default: false,
    }
  },
};
</script>
